module.exports = __webpack_public_path__ + "Server-Default.TentacleActive.5243129272de54aa8f0549a9bbad1a71.hashedasset.svg";